import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { ToggleButton, ToggleButtonGroup, Paper } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';
import Navbar from '../Navbar/Navbar';

const Dashboard = () => {
  const [stats, setStats] = useState({
    vistas: 0,
    usuarios: 0,
    clientes: 0,
    pedidos: 0,
    productosNegados: 0,
  });
  const [tipoReporte, setTipoReporte] = useState("cliente");
  const [pedidos, setPedidos] = useState([]);
  const [reporteClientes, setReporteCliente] = useState([]);
  const [reporteAsesores, setReporteAsesor] = useState([]);
  const [reporteZona, setReporteZona] = useState([]);
  const [reporteClasificacion, setReporteClasificacion] = useState([]);
  const [pedidosPorDia, setPedidosPorDia] = useState([]);
  const [negadosPorDia, setNegadosPorDia] = useState([]);

  useEffect(() => {
    fetchEstadisticas();
    console.log(pedidos);
  }, []);

  const fetchEstadisticas = async () => {
    try {
      const res = await fetch(`https://bibliotecadlago.com/php/estadisticasv2.php`);
      const data = await res.json();

      setStats({
        vistas: data.vistas,
        usuarios: data.usuariosTotales,
        clientes: data.usuariosClientes,
        pedidos: data.totalPedidos,
        productosNegados: data.totalNegados,
      });

      setPedidosPorDia(data.pedidosPorDia);
      setNegadosPorDia(data.negadosPorDia);
      setReporteCliente(data.pedidosPorCliente);
      setPedidos(data.Pedidos);

      setReporteAsesor(data.pedidosPorAsesor);
      setReporteZona(data.pedidosPorZona);
      setReporteClasificacion(data.pedidosPorClasificacion);
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  };

  const getChartData = (data, label, color) => ({
    labels: data.map(item => item.fecha),
    datasets: [{
      label,
      data: data.map(item => item.total),
      fill: false,
      backgroundColor: color,
      borderColor: color,
      tension: 0.2,
    }]
  });

  const columnsCliente = [
    { field: "Cliente", headerName: "Cliente", width: 310 },
    { field: "Asesor", headerName: "Asesor", width: 300 },
    { field: "CantidadPedidos", headerName: "Pedidos", width: 130 },
    { field: "TotalLlantas", headerName: "Llantas", width: 130 },
  ];

  const columnsAsesor = [
    { field: "Asesor", headerName: "Asesor", width: 400 },
    { field: "CantidadPedidos", headerName: "Pedidos", width: 150 },
    { field: "TotalLlantas", headerName: "Llantas", width: 150 },
  ];


  const columnasZona = [
    { field: "Zona", headerName: "Zona", flex: 1 },
    { field: "CantidadPedidos", headerName: "Pedidos", width: 130 },
    { field: "TotalLlantas", headerName: "Llantas", width: 130 },
  ];

  const columnasEnlace = [
    { field: "ClaEnlaceMichelin", headerName: "Clasificación", flex: 1 },
    { field: "CantidadPedidos", headerName: "Pedidos", width: 130 },
    { field: "TotalLlantas", headerName: "Llantas", width: 130 },
  ];

  return (
    <>
      <Navbar />
      <Box p={3}>
        <Typography variant="h4" align="center" gutterBottom>
          Dashboard
        </Typography>

        <Grid container spacing={3} justifyContent="center" mb={6}>
          {[{
            label: 'Vistas',
            value: stats.vistas
          }, {
            label: 'Usuarios registrados',
            value: stats.usuarios
          }, {
            label: 'Clientes',
            value: stats.clientes
          }, {
            label: 'Pedidos',
            value: stats.pedidos
          }, {
            label: 'Productos negados',
            value: stats.productosNegados
          }].map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card sx={{ height: '100%', boxShadow: 3 }}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Typography variant="h6" gutterBottom>
                    {item.label}
                  </Typography>
                  <Typography variant="h3" color="primary">
                    {item.value}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} md={10}>
            <Card sx={{ padding: 3 }}>
              <Typography variant="h6" align="center" gutterBottom>
                Pedidos por día
              </Typography>
              <Box sx={{ height: 200, width: 400 }}>
                <Line data={getChartData(pedidosPorDia, 'Pedidos', '#1976d2')} />
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={10}>
            <Card sx={{ padding: 3 }}>
              <Typography variant="h6" align="center" gutterBottom>
                Productos negados por día
              </Typography>
              <Box sx={{ height: 200, width: 400 }}>
                <Line data={getChartData(negadosPorDia, 'Negados', '#d32f2f')} />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" gap={4} mt={4}>

        {/* TABLA ZONA */}
        <Paper elevation={4} sx={{ width: "100%", maxWidth: 700, p: 3, borderRadius: 3 }}>
          <Typography variant="h6" fontWeight="bold" mb={2} align='center'>
            Reporte por Zona
          </Typography>

          <DataGrid
            rows={reporteZona.map((row, index) => ({ id: index, ...row }))}
            columns={columnasZona}
            autoHeight
            hideFooter
          />
        </Paper>

        {/* TABLA CLASIFICACIÓN */}
        <Paper elevation={4} sx={{ width: "100%", maxWidth: 700, p: 3, borderRadius: 3 }}>
          <Typography variant="h6" fontWeight="bold" mb={2} align='center'>
            Reporte por Clasificación Michelin
          </Typography>

          <DataGrid
            rows={reporteClasificacion.map((row, index) => ({ id: index, ...row }))}
            columns={columnasEnlace}
            autoHeight
            hideFooter
          />
        </Paper>

      </Box>
      <br></br>
      <Box display="flex" flexDirection="column" alignItems="center" gap={1} mt={2}>
        <Typography
          variant="h5"
          fontWeight="bold"
          textAlign="center"
        >
          Reportes
        </Typography>

        <ToggleButtonGroup
          value={tipoReporte}
          exclusive
          onChange={(e, newValue) => {
            if (newValue !== null) setTipoReporte(newValue);
          }}
          size="small"
        >
          <ToggleButton value="cliente">
            Por Cliente
          </ToggleButton>
          <ToggleButton value="asesor">
            Por Asesor
          </ToggleButton>
        </ToggleButtonGroup>
        <Paper elevation={4} sx={{ width: "100%", maxWidth: 900, p: 3, borderRadius: 3 }}>
          <DataGrid
            rows={(tipoReporte === "cliente" ? reporteClientes : reporteAsesores)
              .map((row, index) => ({ id: index, ...row }))
            }
            columns={tipoReporte === "cliente" ? columnsCliente : columnsAsesor}
            autoHeight
            pageSize={5}
          />
        </Paper>
      </Box>
    </>
  );
};

export default Dashboard;
